module.exports = __webpack_public_path__ + "img/nameplate_bg.eba33a8f.png";